import { FontWeights } from '@uifabric/styling';

export const LabelStyles = {
  root: {
    fontWeight: FontWeights.regular,
  },
};
